import { callBackendApi } from "../axiosInstances/backendInstance/apiRequest";

const resourceConfigBySource = {
  appointment: {
    endpoint: "/appointments",
  },
  class_booking: {
    endpoint: "/class-bookings",
  },
  class_session: {
    endpoint: "/class-sessions",
  },
};

function getResourceConfig(source) {
  return resourceConfigBySource[source] || null;
}

export async function fetchAgendaItemDetails(item) {
  const config = getResourceConfig(item?.source);

  if (!config || !item?.source_id) {
    return {
      success: false,
      error: "This agenda item cannot be opened.",
    };
  }

  return callBackendApi(`${config.endpoint}/${item.source_id}`, "GET");
}

export async function updateAgendaItem(item, payload) {
  const config = getResourceConfig(item?.source);

  if (!config || !item?.source_id) {
    return {
      success: false,
      error: "This agenda item cannot be updated.",
    };
  }

  return callBackendApi(`${config.endpoint}/${item.source_id}`, "PUT", payload);
}
